<template>
  <div class="relative md:hidden">
    <!-- Contenedor del submenú -->
    <div class="overflow-x-auto scrollbar-hide text-xs font-medium bg-gray-200">
      <ul class="hidden space-x-2 whitespace-nowrap p-2" ref="menu">
        <li v-for="(item, index) in items" :key="index"
          class="px-1 py-1.5 rounded hover:bg-black hover:text-white cursor-pointer"
          :class="{ 'bg-black text-white': selected === index }" @click="goTo(index)">
          {{ item.name }}
        </li>
        <!-- Ultimo vacio para el margen -->
        <li class="px-4 py-1.5 rounded"></li>
      </ul>
    </div>

    <!-- Botón de deslizar izquierda -->
    <!-- <button class="absolute top-0 left-0 h-full px-2 bg-gradient-to-r from-white/70 to-transparent text-gray-600"
            @click="scrollLeft">
            &larr;
        </button> -->

    <!-- Botón de deslizar derecha -->
    <button
      class="absolute top-0 right-0 h-full px-2 bg-gradient-to-l from-white/70 to-transparent text-gray-600 show-if-is-needed"
      @click="scrollRight">
      &rarr;
    </button>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
export default {
  data() {
    return {
      items: [
        {
          name: "Mi perfil",
          to: "perfil",
        },
        {
          name: "Mi billetera",
          to: "billetera",
        },
        {
          name: "Mi suscripción",
          to: "mi-suscripcion",
        },
      ],
      selected: 0,
    };
  },
  methods: {
    goTo(index) {
      this.selected = index;
      this.$router.push("/" + this.items[index].to);
    },
    scrollLeft() {
      const menu = this.$refs.menu;
      menu.scrollBy({ left: -150, behavior: "smooth" });
    },
    scrollRight() {
      const menu = this.$refs.menu;
      menu.scrollBy({ left: 150, behavior: "smooth" });
    },
    calcularBotonDesplazamiento() {
      const menu = this.$refs.menu;
      const botonDesplazamiento = document.querySelector(".show-if-is-needed");
      if (!menu || !botonDesplazamiento) return;
      if (menu.scrollWidth > menu.clientWidth) {
        botonDesplazamiento.style.display = "block";
      } else {
        botonDesplazamiento.style.display = "none";
      }
    },
  },
  async mounted() {
    // Si el usuario es alumno, agregar el item Mi Taller, obtener el usuario del store
    const usuario = useAuthStore().usuario;
    console.log(usuario);
    if (usuario?.alumno) {
      this.items.push({
        name: "Taller 1",
        to: "mi-taller",
      });
    }
    if (usuario?.alumno2) {
      this.items.push({
        name: "Taller 2",
        to: "virtuales/hernan-casciari/taller-2",
      });
    }

    // Agregar el cerrar sesion
    this.items.push({
      name: "Cerrar sesión",
      to: "cerrar-sesion",
    });

    // Detectar si es necesario mostrar el botón de desplazamiento
    const menu = this.$refs.menu;
    menu.addEventListener("scroll", () => {
      this.calcularBotonDesplazamiento();
    });
    // Agregar un evento resize para recalcular el botón de desplazamiento
    window.addEventListener("resize", () => {
      this.calcularBotonDesplazamiento();
    });

    this.calcularBotonDesplazamiento();

    // Detectar la ruta actual y seleccionar el item correspondiente
    const ruta = this.$route.path;
    const item = this.items.find((i) => i.to === ruta.slice(1));
    if (item) {
      this.selected = this.items.indexOf(item);
    }
  },
};
</script>

<style>
/* Oculta el scrollbar para una apariencia más limpia */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
  font-family: Inter, sans-serif;
  z-index: 9999;
}
</style>
